<template>
    <div class="users container-fluid h-100 pt-3">
        <div class="row h-100 m-0">
            <div class="col-lg-7 col-xl-8 h-100 overflow-auto">
                <div class="position-sticky title d-flex align-items-center pb-2">
                    <div class="flex-grow-1">
                        <b-dropdown class="border-0 rounded-0"
                                    variant="link"
                                    toggle-class="text-decoration-none p-0"
                                    no-caret>
                            <template v-slot:button-content>
                                <h1 class="text-dark font-weight-bolder col pl-0 mb-0">
                                    <span class="">
                                        {{ userRoleFilter ? $config.roleMap[userRoleFilter] : "所有用戶" | capitalize }}
                                    </span>
                                    <small>
                                        <font-awesome-icon icon="caret-down"></font-awesome-icon>
                                    </small>
                                </h1>
                            </template>
                            <b-dropdown-item-button v-on:click="userRoleFilter = null">
                                所有用戶
                            </b-dropdown-item-button>
                            <b-dropdown-item-button v-for="role in roles"
                                                    v-bind:key="role"
                                                    v-on:click="userRoleFilter = role">
                                {{ $config.roleMap[role] }} ({{ userRoleHistogram[role] }})
                            </b-dropdown-item-button>
                        </b-dropdown>
                    </div>

                    <div class="d-flex align-items-center">
                        <button class="btn btn-light text-nowrap rounded-pill shadow-sm mr-2"
                                v-on:click="isAddUserModalOpened = true">
                            <font-awesome-icon class="mr-2"
                                               icon="plus-square">
                            </font-awesome-icon>新增/邀請用戶
                        </button>

                        <b-pagination class="mb-0"
                                      size="sm"
                                      v-bind:total-rows="keywordFilteredUsers.length"
                                      v-bind:per-page="usersPerPage"
                                      v-model="currentPage">
                        </b-pagination>
                    </div>
                </div>

                <div class="position-sticky user-list-heading pt-1 pb-3">
                    <div class="">
                        <search-bar class="search-bar"
                                    has-filter
                                    v-model="keyword">
                        </search-bar>
                    </div>
                </div>

                <div class="list-group mb-3">
                    <div class="empty-notice text-center"
                         v-if="keywordFilteredUsers.length === 0">
                        No user {{ statusFilter }}
                    </div>
                    <template v-else>
                        <user-item v-for="user in paginatedUsers"
                                   v-bind:key="user._id"
                                   v-bind:user="user">
                        </user-item>
                    </template>
                </div>
            </div>

            <div class="col-lg-5 col-xl-4 mx-3 mx-lg-0 p-lg-0 h-100">
                <router-view></router-view>
            </div>
        </div>

        <modal-user v-if="userRole === 'vending-admin'"
                    v-model="isAddUserModalOpened">
        </modal-user>
    </div>
</template>

<script>
    import {
        BPagination,
        BFormSelect,
        BFormGroup,
        BFormCheckbox,
        BDropdown,
        BDropdownItemButton,
    } from "bootstrap-vue";

    import UserItem from "../components/Users/UserItem";
    import SearchBar from "../components/Users/SearchBar";
    import ModalUser from "../components/Users/ModalUser";

    import Fuse from "fuse.js";
    const fuseOptions = {
        keys: [
            "countryCode",
            "phone",
            "name",
        ]
    };

    export default {
        name: "Users",
        components: {
            ModalUser,
            SearchBar,
            UserItem,
            BPagination,
            BFormSelect,
            BFormGroup,
            BFormCheckbox,
            BDropdown,
            BDropdownItemButton,
        },
        data() {
            return {
                usersPerPage: 20,
                currentPage: 1,

                isAddUserModalOpened: false,

                roles: [
                    "vending-admin",
                    "vending-vendor",
                    "vending-site-manager",
                ],
                userRoleFilter: null,
                statusFilter: null,
                keyword: "",
            };
        },
        computed: {
            userRole () {
                return this.$store.state.user.user.role;
            },

            users () {
                return this.$store.getters["users/all"]
                    .slice(0)
                    .reverse();
            },

            userRoleHistogram () {
                return this.users
                    .reduce(
                        (acc, { role }) => {
                            if (acc[role]) {
                                acc[role] ++;
                            } else {
                                acc[role] = 1;
                            }
                            return acc;
                        },
                        {}
                    );
            },

            roleFilteredUsers () {
                if (this.userRoleFilter) {
                    return this.users
                        .filter(
                            ({ role }) => role === this.userRoleFilter
                        );
                }
                return this.users;
            },

            keywordFilteredUsers () {
                if (this.keyword.length > 2) {
                    const fuse = new Fuse(
                        this.roleFilteredUsers,
                        fuseOptions
                    );
                    return fuse
                        .search(this.keyword)
                        .map(({ item }) => item);
                }
                return this.roleFilteredUsers;
            },

            paginatedUsers () {
                return this.keywordFilteredUsers
                    .slice(
                        this.usersPerPage * (this.currentPage - 1),
                        this.usersPerPage * this.currentPage
                    );
            },
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
    .title {
        top: 0;
        z-index: 4;
    }

    .user-list-heading {
        top: 52px;
        z-index: 3;
    }
</style>
